import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;
`;

export const FormContainer = styled.div`
  margin: 2rem 0rem;

  form {
    .react-select__control {
      overflow: unset;

      .react-select__value-container {
        height: 36px !important;
      }

      .css-1uccc91-singleValue {
        display: flex !important;
        align-items: center !important;
      }
    }

    .react-select__menu {
      .react-select__menu-list {
        display: flex;
        flex-direction: column;

        .react-select__option {
          display: flex;
          align-items: center;
        }
      }
    }
  }
`;

export const FormFooter = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const InputContainer = styled.div`
  display: block;
  margin: 1rem 0rem;

  label {
    display: block;
    width: 100%;
    min-height: 16px;
    font-size: 14px;
    color: rgb(135, 134, 139);
    margin-bottom: 8px;
  }

  > div {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background: #fff;
  }
`;

export const InputGroup = styled.div`
  position: relative;
  flex: 1 1 0%;
  border: 1px solid;
  border-color: #c4c4c4;
  border-radius: 0.2rem;
  transition: 0.3s ease-in;

  input {
    width: 100%;
    height: 60px;
    font-size: 16px;
    background: #fff;
    color: ${props => props.theme.textColor};
    padding: 0px 1em;
    border-radius: 5px;
  }
`;
